import style from "./apptopicbanner.module.scss";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import useAppModernisation from "../../hooks/useAppModernisation";
import { useFindInPage } from "../../hooks/FindInPageHooks/useFindInPage";
import { useEffect } from "react";
import { closeModal } from "../../features/findInPage/FindInPageSlice";
import { useTableOfContents } from "../../hooks/tableOfContentsHooks/useTableOfContents";
import FavouriteButton from "../FavouriteButton/FavouriteButton";
import useToast from "../../hooks/useToast";
import useGoBack from "../../hooks/useGoBack";
import { useLocation } from "react-router-dom";
import { useIsPregnancyBreastfeedingPage } from "../../utils/pregnancyPageUtils";
import MoreButton from "./MoreButton";
import { setIsMobileView } from "../../features/fontSizeAdjustor/FontSizeAdjustorSlice";
import { useTableOfContentsItems } from "../../hooks/tableOfContentsHooks/useTableOfContentsItems";

const DEFAULT_FAVOURITE_TOAST_DURATION = 3000;

const TopBar = ({
  topicTitle,
  topicUrl,
  guideline,
  expandExpertGroupsSideBar,
  expandUpdatesSideBar,
  setShowTopicActionBar,
  msPath,
}) => {
  const { isWebModernisationEnabled } = useAppModernisation();
  const { goBack } = useGoBack();
  const dispatch = useDispatch();
  const findInPage = useFindInPage();
  const tableOfContents = useTableOfContents();
  const iconRight = classNames("tg-icons-LeftArrow", "iconSize", style.rightArrow);
  const iconToc = classNames("tg-icons-FormattedListBullet", "iconSize");
  const iconFindInPage = classNames("tg-icons-FindInPage", "iconSize");
  const pageTocStyle = classNames("size-14", style.button, style.push);
  const standardButtonStyle = classNames("size-14", style.button);
  const toast = useToast();
  const { pathname, search } = useLocation();

  useTableOfContentsItems(msPath);

  const triggerToast = (added) => {
    toast.triggerToast({
      type: "info",
      primaryMessage: added ? "Added to favourites" : "Removed from favourites",
      rightText: setIsMobileView
        ? '<a href="/app/favourites">View</a>'
        : '<a href="/app/accountLanding">View</a>',
      autoHideDuration: DEFAULT_FAVOURITE_TOAST_DURATION,
    });
  };

  const handleOpenTocModal = (e) => {
    e.stopPropagation();
    findInPage.closeModal();
    tableOfContents.openModal();
  };

  // Close modal when page loaded
  useEffect(() => {
    dispatch(closeModal());
  }, [dispatch]);

  const isPbsPage = useIsPregnancyBreastfeedingPage(search, pathname);

  return (
    <div className={style.topBar}>
      <button
        type="button"
        className={classNames("size-14", style.button, style.buttonRight)}
        onClick={goBack}
        aria-label="Go back"
      >
        <i className={iconRight}></i>
      </button>
      {isWebModernisationEnabled ? (
        <>
          <FavouriteButton
            sectionTitle={topicTitle}
            sectionUrl={tableOfContents?.tableOfContents?.msPath}
            type="topic"
            topicSection={guideline}
            triggerToast={triggerToast}
            styling={pageTocStyle}
          />
          {!isPbsPage && (
            <MoreButton
              expandExpertGroupsSideBar={expandExpertGroupsSideBar}
              expandUpdatesSideBar={expandUpdatesSideBar}
              setShowTopicActionBar={setShowTopicActionBar}
              msPath={msPath}
            ></MoreButton>
          )}
        </>
      ) : (
        <>
          <button
            type="button"
            className={pageTocStyle}
            aria-label="Page Table of Contents Panel"
            onClick={handleOpenTocModal}
          >
            <i className={iconToc}></i>
          </button>
          <button
            type="button"
            className={standardButtonStyle}
            aria-label="Find in page"
            onClick={findInPage.openModal}
          >
            <i className={iconFindInPage}></i>
          </button>
          <FavouriteButton
            sectionTitle={topicTitle}
            sectionUrl={tableOfContents?.tableOfContents?.msPath}
            type="topic"
            topicSection={guideline}
            triggerToast={triggerToast}
            styling={standardButtonStyle}
          />
        </>
      )}
    </div>
  );
};
export default TopBar;
